import React, { useState, useCallback, useEffect } from "react";
import "./organization-settings-privacy.scss";

import { GSForm, GSSidePanelPage } from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useMatch } from "react-router-dom";
import {
  selectCurrentOrganization,
  selectOrganization,
  selectOrganizationNotifications,
  clearNotifications,
  selectOrganizationSettings,
  getOrgSettings,
  setSelectedOrganizationSetting,
  saveOrganizationSettings,
} from "../../reducers/organizationSlice";
import { privacyForm } from "../../forms/SettingsForm";

const OrganizationSettingsPrivacy = () => {
  const [isValid, setIsValid] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const matchEdit = useMatch("/:id/settings/privacy/*");

  const orgNotifications = useSelector(selectOrganizationNotifications);
  const currentOrganization = useSelector(selectCurrentOrganization);
  const orgSettings = useSelector(selectOrganizationSettings);

  const load = useCallback(() => {
    const { id } = matchEdit.params;
    if (id) {
      dispatch(selectOrganization(id));
      dispatch(getOrgSettings(id));
    }
  }, [dispatch, matchEdit.params]);

  useEffect(() => {
    load();
  }, [load]);

  let context = {};

  context.validationFailed = () => {
    if (isValid) {
      setIsValid(false);
    }
  };

  context.updateOrganiation = (value, property) => {
    setIsValid(true);
  };
  context.toggleTournamentVisibility = () => {
    setIsValid(true);
    dispatch(
      setSelectedOrganizationSetting({
        ...orgSettings,
        hideTournamentSearch: !orgSettings.hideTournamentSearch,
      })
    );
  };
  context.formIsValid = () => {
    return isValid;
  }
  const saveOrganization = () => {
    let save = { ...orgSettings };
    save.organization = currentOrganization;
    dispatch(saveOrganizationSettings(save));
  };
  const leftNavigation = () => {
    timeoutAction()
    const { id } = matchEdit.params;
    navigate(`/${id}/settings`);
  };

  const getActions = () => {
    let actions = [
      {
        name: "Save",
        isDisabled: !isValid,
        action: saveOrganization,
        type: "black",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];

    return actions;
  };

  const getNavigation = () => {
    return {
      title: "Privacy",
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const hasNotifications = (notifications) => {
    return notifications && notifications.length > 0;
  };

  const getBanner = () => {
    const slideOutNotifications = orgNotifications;
    if (hasNotifications(slideOutNotifications)) {
      return {
        notifications: slideOutNotifications.map((n) => ({
          ...n,
          pageActions: getBannerActions(),
        })),
        timeoutAction: timeoutAction,
        timeout: 10000,
      };
    }
  };

  const timeoutAction = () => {
    dispatch(clearNotifications());
  };

  const getBannerActions = () => {
    return [
      {
        id: 1,
        title: "View Settings",
        size: "secondary",
        actionClick: leftNavigation,
      },
    ];
  };

  const getContent = () => {
    return (
      <GSForm
        formTitle="Privacy"
        formSections={privacyForm(context, orgSettings)}
      />
    );
  };
  const getDrawer = () => {
    return {
      actions: getActions(),
    };
  };
  return (
    <organization-settings-privacy>
      <GSSidePanelPage
        header={getNavigation()}
        banner={getBanner()}
        content={getContent()}
        drawer={getDrawer()}
      />
    </organization-settings-privacy>
  );
};

export default OrganizationSettingsPrivacy;
